// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"142":"chunk_statsgrid","855":"chunk_announcements"}[chunkId] || chunkId) + "/oskari.min.css";
};